import initialState from './initialState';

export const GetSchedulerTasksReducer = {
  pending: (state) => ({
    ...state,
    loading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      list: data.schedulerTasks,
      loading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    loading: 'failed',
  }),
};

export const GetSchedulerTaskHistoryReducer = {
  pending: (state) => ({
    ...state,
    historyLoading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      historyList: data.schedulerTaskHistory,
      historyLoading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    historyLoading: 'failed',
  }),
};

export const ClearSchedulerTaskHistoryReducer = {
  pending: (state) => ({
    ...state,
    historyLoading: 'pending',
  }),
  fulfilled: (state) => ({
    ...state,
    historyList: [],
    historyLoading: 'succeeded',
  }),
  rejected: (state) => ({
    ...state,
    historyLoading: 'failed',
  }),
};

export const GetSchedulerTaskByIdReducer = {
  pending: (state) => ({
    ...state,
    loading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      selectedItem: data.schedulerTask,
      loading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    loading: 'failed',
  }),
};

export const CreateSchedulerTaskReducer = {
  pending: (state) => ({
    ...state,
    loading: 'pending',
  }),
  fulfilled: (state) => ({
    ...state,
    loading: 'succeeded',
  }),
  rejected: (state) => ({
    ...state,
    loading: 'failed',
  }),
};

export const UpdateSchedulerTaskReducer = {
  pending: (state) => ({
    ...state,
    loading: 'pending',
  }),
  fulfilled: (state) => ({
    ...state,
    loading: 'succeeded',
  }),
  rejected: (state) => ({
    ...state,
    loading: 'failed',
  }),
};

export const DeleteSchedulerTaskReducer = {
  pending: (state) => ({
    ...state,
    loading: 'pending',
  }),
  fulfilled: (state) => ({
    ...state,
    loading: 'succeeded',
  }),
  rejected: (state) => ({
    ...state,
    loading: 'failed',
  }),
};

export const ChangeInactiveStatusSchedulerTaskReducer = {
  pending: (state) => ({
    ...state,
    loading: 'pending',
  }),
  fulfilled: (state) => ({
    ...state,
    loading: 'succeeded',
  }),
  rejected: (state) => ({
    ...state,
    loading: 'failed',
  }),
};

export const ClearNextRunAtSchedulerTaskReducer = {
  pending: (state) => ({
    ...state,
    loading: 'pending',
  }),
  fulfilled: (state) => ({
    ...state,
    loading: 'succeeded',
  }),
  rejected: (state) => ({
    ...state,
    loading: 'failed',
  }),
};

export const ResetSchedulerTasksStateReducer = () => initialState;

export const ResetSelectedSchedulerTaskReducer = (state) => ({
  ...state,
  selectedItem: null,
});
